'use strict';

var ColorpickerProvider = function () {
  var config = this;

  this.colors = [
    '#9E226E',
    '#CA4839',
    '#E17644',
    '#EFB01B',
    '#F1D010',
    '#8CB940',
    '#43A646',

    '#4E3B81',
    '#0B5791',
    '#3A89BF',
    '#58AFD1',
    '#9CCBAF',
    '#989898',
    '#4F4F56'
  ];

  this.$get = function () {
    return new Colorpicker(config);
  };

  var Colorpicker = function (config) {
    this.getColors = function () {
      return config.colors;
    };
  };
};

module.exports = ColorpickerProvider;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/colorpicker/src/ColorpickerProvider.js